export default __webpack_public_path__ + "static/media/supper_apps_background_xl2.80d9597e.jpg";